<template>
  <div id="app">
    <nav-bar />
    <router-view/>
    <app-footer />
  </div>
</template>

<script>
import NavBar from '@/components/shared/NavBar'
import AppFooter from '@/components/shared/Footer'

export default {
  name: 'App',
  components: {
    NavBar,
    AppFooter
  }
}
</script>

<style>
@import './assets/css/responsive.css';

body {
  margin: 0;
  padding: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8f8f8;
}
#app {
  color: #2c3e50;
  width: 100%;
  overflow-x: hidden;
}

/* 全局表格响应式样式 */
@media (max-width: 576px) {
  .el-table {
    width: 100%;
    overflow-x: auto;
    display: block;
  }

  /* 确保图片响应式 */
  img {
    max-width: 100%;
    height: auto;
  }

  /* 修复Element UI组件在移动端的一些常见问题 */
  .el-dialog {
    width: 95% !important;
    margin: 10px auto !important;
  }

  .el-message-box {
    width: 90% !important;
  }

  .el-date-picker {
    width: 100% !important;
  }

  .el-tabs__item {
    padding: 0 12px !important;
  }
}

/* 移动设备上按钮更容易点击 */
@media (max-width: 768px) {
  button, 
  .el-button,
  [role="button"],
  input[type="submit"],
  input[type="button"] {
    min-height: 44px;
    min-width: 44px;
    padding: 10px 15px;
  }

  /* 增加表单控件大小便于触摸 */
  input, select, textarea {
    font-size: 16px !important; /* 防止iOS缩放 */
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue